import React, { Component } from 'react';
import accountIcon from '../../images/accountico.svg';
import generalIcon from '../../images/generalico.svg';
import myCompanyIcon from '../../images/myCompanyIco.svg';
import { Link } from "react-scroll";
import { Translation } from "react-i18next";
import './side-navigation.scss'
import { GetLinkForOldMyCompany } from "../../helpers/link-provider";
import { Configuration } from '../../types/Configuration';

type Props = {
    selectedLanguage: string,
    isMobile: boolean
    configuration: Configuration
}

type State = {
    open: boolean,
    myCompanyLink: string
}

const mobileScrollToLink = -115, desktopScrollToLink = -67;

class SideNavigation extends Component<Props, State> {
    constructor(props: Props) {
        super(props);

        // Initial state
        this.state = { open: false, myCompanyLink: "" };
    }

    componentDidMount() {
        this.setLinks();
    }

    componentDidUpdate(prevProps: Props) {
        if (prevProps.selectedLanguage !== this.props.selectedLanguage) {
            this.setLinks();
        }
    }

    setLinks = () => {
        let myCompanyLink = GetLinkForOldMyCompany(this.props.configuration.docuwareBaseUrl, this.props.selectedLanguage);

        this.setState({ myCompanyLink: myCompanyLink });
    }

    toggle() {
        this.setState({
            open: !this.state.open
        });
    }
    
    render() {
        return (
            <div className="side-navigation-container">
                <div className="sm-devices-menu">
                    <button onClick={this.toggle.bind(this)} className="menu-button"><span className="material-icons burger-menu-ico">menu</span></button>
                    <h4><Translation>{t => t("My Account")}</Translation></h4>
                </div>
                <div className={"main-menu" + (this.state.open ? " open" : "")}>
                    <button className="close-button" onClick={this.toggle.bind(this)}><span className="material-icons">close</span></button>
                    <h4><Translation>{t => t("My Account")}</Translation></h4>
                    <Link
                        to="GeneralArea"
                        spy={true}
                        smooth={true}
                        offset={this.props.isMobile ? mobileScrollToLink : desktopScrollToLink}
                        duration={500}
                        lang={this.props.selectedLanguage}
                    >
                        <img src={generalIcon} alt="" />
                        <span><Translation>{t => t("General")}</Translation></span>
                    </Link>
                    <Link
                        to="AccountArea"
                        spy={true}
                        smooth={true}
                        offset={this.props.isMobile ? mobileScrollToLink : desktopScrollToLink}
                        duration={500}
                        lang={this.props.selectedLanguage}
                    >
                        <img src={accountIcon} alt="" />
                        <span><Translation>{t => t("Account")}</Translation></span>
                    </Link>
                    <Link
                        to="CompRelArea"
                        spy={true}
                        smooth={true}
                        offset={this.props.isMobile ? mobileScrollToLink : desktopScrollToLink}
                        duration={500}
                        lang={this.props.selectedLanguage}
                    >
                        <img src={myCompanyIcon} alt="" />
                        <span><Translation>{t => t("Companies")}</Translation></span>
                    </Link>
                </div>
            </div>
        )
    }
}

export default SideNavigation;